import { get_plan_excel_import_setting_by_flag } from 'liyu-pc-base/api/sys-model';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const org = userStore.currentOrg;
  const search_config: any = {
    model: {
      flag: org?.id,
      is_active: true,
      page_index: 1,
      page_size: 2000,
    },
    watch: [],
  };

  return {
    getData: get_plan_excel_import_setting_by_flag,
    searchConfig: search_config,
  };
};
